export default "__VITE_ASSET__DGB4ftQj__"